"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonType = exports.ButtonSize = void 0;
var preact_1 = require("preact");
var classnames = require("classnames");
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var a11y_wrapper_1 = require("../../hoc/a11y-wrapper");
var icon_1 = require("../../icon");
var styles = require("./Button.scss");
var Tooltip = kaltura_player_js_1.ui.Components.Tooltip;
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["small"] = "small";
    ButtonSize["medium"] = "medium";
    ButtonSize["large"] = "large";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["primary"] = "primary";
    ButtonType["danger"] = "danger";
    ButtonType["translucent"] = "translucent";
    ButtonType["borderless"] = "borderless";
    ButtonType["borderlessTranslucent"] = "borderlessTranslucent";
    ButtonType["secondary"] = "secondary";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = (0, preact_1.createRef)();
        _this.renderChildren = function () {
            var props = _this.props;
            if (props.loading) {
                return ((0, preact_1.h)("span", null,
                    (0, preact_1.h)(icon_1.Icon, { name: 'spinner', size: icon_1.IconSize[props.size] })));
            }
            return props.children ? (0, preact_1.h)("span", null, props.children) : null;
        };
        _this.renderButton = function () {
            var _a;
            var props = _this.props;
            var classNames = classnames(styles.button, styles[props.size], styles[props.type], props.className, (_a = {},
                _a[styles.disabled] = props.disabled,
                _a[styles.loading] = props.loading,
                _a[styles.withIcon] = props.children && props.icon,
                _a[styles.iconOnly] = !props.children && props.icon,
                _a));
            var buttonProps = __assign(__assign(__assign(__assign({ ref: _this.buttonRef, disabled: props.disabled, 'aria-disabled': props.disabled, 'aria-busy': props.loading, tabIndex: props.tabIndex, className: classNames }, (props.ariaLabel ? { 'aria-label': props.ariaLabel } : {})), (props.testId ? { 'data-testid': props.testId } : {})), (props.onFocus ? { onFocus: props.onFocus } : {})), (props.onBlur ? { onBlur: props.onBlur } : {}));
            var buttonContent = ((0, preact_1.h)("button", __assign({}, buttonProps),
                (0, preact_1.h)(preact_1.Fragment, null,
                    props.icon && (0, preact_1.h)(icon_1.Icon, { name: props.icon, size: icon_1.IconSize[props.size] }),
                    _this.renderChildren())));
            return props.onClick ? (0, preact_1.h)(a11y_wrapper_1.A11yWrapper, { onClick: props.onClick }, buttonContent) : buttonContent;
        };
        return _this;
    }
    Button.prototype.componentDidMount = function () {
        var _a;
        if (this.props.setRef) {
            this.props.setRef(this.buttonRef.current);
        }
        if (this.props.focusOnMount) {
            (_a = this.buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    Button.prototype.render = function (props) {
        if (props.tooltip) {
            var tooltipProps = __assign(__assign(__assign({ label: props.tooltip.label }, (props.tooltip.type ? { type: props.tooltip.type } : {})), (props.tooltip.className ? { classNames: props.tooltip.className } : {})), (props.tooltip.strictPosition ? { strictPosition: true } : {}));
            return (0, preact_1.h)(Tooltip, __assign({}, tooltipProps), this.renderButton());
        }
        return this.renderButton();
    };
    return Button;
}(preact_1.Component));
exports.Button = Button;
Button.defaultProps = {
    disabled: false,
    focusOnMount: false,
    tabIndex: 0,
    children: null,
    size: ButtonSize.medium,
    icon: null,
    type: ButtonType.primary
};
//# sourceMappingURL=index.js.map